import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import SignupWidget from './components/SignupWidget'
import StartSignupWidget from './components/StartSignupWidget'
import LoginWidget from './components/LoginWidget'
import ResetPasswordWidget from './components/ResetPasswordWidget'

document.addEventListener("DOMContentLoaded", function(event) { 
  const react_signup_widget_elements = document.getElementsByClassName('react-signup-widget')
  for(let i = 0; i < react_signup_widget_elements.length; i++) {
    const node = react_signup_widget_elements[i]
    const data = JSON.parse(node.getAttribute('data-props'))
    ReactDOM.render(<SignupWidget {...data} />, node)
  }
})

document.addEventListener("DOMContentLoaded", function(event) { 
  const react_login_widget_elements = document.getElementsByClassName('react-login-widget')
  for(let i = 0; i < react_login_widget_elements.length; i++) {
    const node = react_login_widget_elements[i]
    const data = JSON.parse(node.getAttribute('data-props'))
    ReactDOM.render(<LoginWidget {...data} />, node)
  }
})

document.addEventListener("DOMContentLoaded", function(event) { 
  const react_reset_password_elements = document.getElementsByClassName('react-reset-password-widget')
  for(let i = 0; i < react_reset_password_elements.length; i++) {
    const node = react_reset_password_elements[i]
    const data = JSON.parse(node.getAttribute('data-props'))
    ReactDOM.render(<ResetPasswordWidget {...data} />, node)
  }
})

document.addEventListener("DOMContentLoaded", function(event) { 
  const react_start_signup_elements = document.getElementsByClassName('react-start-signup-widget')
  for(let i = 0; i < react_start_signup_elements.length; i++) {
    const node = react_start_signup_elements[i]
    const data = JSON.parse(node.getAttribute('data-props'))
    ReactDOM.render(<StartSignupWidget {...data} />, node)
  }
})



// WEBPACK FOOTER //
// ./src/index.js